import { AtHomeTestActivationWorkflowId } from './types';

export const AT_HOME_TEST_ACTIVATION_ROOT_PATH = '/test/activate';

// These paths are used in the happy-path workflow
export const AT_HOME_TEST_ACTIVATION_RELATIVE_PATHS = {
  [AtHomeTestActivationWorkflowId.LANDING]: 'start',
  [AtHomeTestActivationWorkflowId.BARCODE_ENTRY]: 'barcode',
  [AtHomeTestActivationWorkflowId.ACCOUNT]: 'account',
  [AtHomeTestActivationWorkflowId.TEST_SELECTION]: 'select-test',
  [AtHomeTestActivationWorkflowId.TEST_ELIGIBILITY]: 'test-eligibility',
  [AtHomeTestActivationWorkflowId.TEST_INFO]: 'info',
  [AtHomeTestActivationWorkflowId.PRIMARY_CARE_PROVIDER]: 'primary-care-provider',
  [AtHomeTestActivationWorkflowId.PRETEST_COUNSELING]: 'review-before-consent',
  [AtHomeTestActivationWorkflowId.TEST_SPECIFIC_CONSENT]: 'consent',
  [AtHomeTestActivationWorkflowId.INFORMED_DECISION_MAKING]: 'benefits-risks',
  [AtHomeTestActivationWorkflowId.REVIEW]: 'confirm-patient-info',
  [AtHomeTestActivationWorkflowId.SAMPLE_COLLECTION_INSTRUCTIONS]: 'collect-sample',
};

// Error pages
export const AT_HOME_TEST_ACTIVATION_UNAVAILABLE_IN_LOCATION_PATH = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/location-unavailable`;
export const AT_HOME_TEST_ACTIVATION_SEPARATE_ACCOUNT_REQUIRED = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/account-required`;
export const AT_HOME_TEST_ACTIVATION_NOT_ELIGIBLE_FOR_SCREENING = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/not-eligible-for-screening`;
export const AT_HOME_TEST_ACTIVATION_ALTERNATIVE_AVAILABLE = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/alternative-available`;
export const AT_HOME_TEST_ACTIVATION_NOT_ELIGIBLE_DUE_TO_PROGRAM = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/program-not-eligible`;

// Deciding not to continue from informed decision page
export const AT_HOME_TEST_ACTIVATION_WILL_NOT_PROCEED = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/thank-you`;
export const AT_HOME_TEST_ACTIVATION_TALK_TO_PROVIDER = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/talk-with-provider`;

// Electing to collect the sample later (from the sample collection timing eligibility step)
export const AT_HOME_TEST_ACTIVATION_SCREENING_REMINDER_CADENCE = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/screening-reminder-cadence`;
export const AT_HOME_TEST_ACTIVATION_SCREENING_REMINDER_CONFIRMATION = `${AT_HOME_TEST_ACTIVATION_ROOT_PATH}/reminder-set`;
